import { FormattedMessage } from "react-intl";
import {
  BsEye,
  BsFillBarChartFill,
  BsHexagon,
  BsLaptop,
  BsLightning,
} from "react-icons/bs";
import {
  GiTestTubes,
  GiPoliceBadge,
  GiSpeaker,
  GiCoveredJar,
} from "react-icons/gi";
import {
  AiFillSafetyCertificate,
  AiFillSetting,
  AiFillCloseCircle,
  AiOutlineBarChart,
  AiOutlineSafety,
  AiOutlineUser,
  AiOutlineSetting,
  AiFillQuestionCircle,
} from "react-icons/ai";
import { FaMedal, FaChartLine, FaUserCircle } from "react-icons/fa";
import { GoVerified } from "react-icons/go";
import { RiComputerLine } from "react-icons/ri";
import {
  MdOutlineFolderShared,
  MdMemory,
  MdDashboardCustomize,
  MdComputer,
  MdRecycling,
} from "react-icons/md";
import {
  BiBlock,
  BiCube,
  BiMessageRounded,
  BiNetworkChart,
  BiTargetLock,
  BiTask,
} from "react-icons/bi";

import { VscCircleLargeFilled } from "react-icons/vsc";
import { BsCircleSquare, BsCircleFill, BsCircle } from "react-icons/bs";
import { MdRecordVoiceOver, MdMovie } from "react-icons/md";
import {
  AiFillRocket,
  AiOutlineVideoCamera,
  AiFillSound,
} from "react-icons/ai";
import { DiGoogleAnalytics } from "react-icons/di";
import { FiEdit, FiTarget } from "react-icons/fi";
import { IoEarth, IoGameController, IoWallet } from "react-icons/io5";
import { FaPaintBrush, FaPenNib, FaMicrophone } from "react-icons/fa";
import { HiChartBar, HiSpeakerphone } from "react-icons/hi";
import { SiTarget } from "react-icons/si";

import { ReactComponent as Why1 } from "../../../assets/Home/why1.svg";
import { ReactComponent as Why2 } from "../../../assets/Home/why2.svg";
import { ReactComponent as Why3 } from "../../../assets/Home/why3.svg";
import { ReactComponent as Why4 } from "../../../assets/Home/why4.svg";
import { ReactComponent as Why5 } from "../../../assets/Home/why5.svg";
import { ReactComponent as Why6 } from "../../../assets/Home/why6.svg";

import portfolio1 from "../../../assets/Home/portfolio1.png";
import portfolio2 from "../../../assets/Home/portfolio2.png";
import portfolio3 from "../../../assets/Home/portfolio3.png";
import portfolio4 from "../../../assets/Home/portfolio4.png";
import portfolio5 from "../../../assets/Home/portfolio5.png";

import { ReactComponent as Clients1 } from "../../../assets/Home/clients1.svg";
import { ReactComponent as Clients2 } from "../../../assets/Home/clients2.svg";
import { ReactComponent as Clients3 } from "../../../assets/Home/clients3.svg";

export const whyData1 = [
  {
    side1: [
      {
        icon: <Why1 />,
        title: (
          <FormattedMessage
            id="home-why1-title"
            defaultMessage="Virtual Hands"
          />
        ),
        text: (
          <FormattedMessage
            id="home-why1-text"
            defaultMessage="With decades of experience in networking and IT infrastructure, we understand the importance of reliable and immediate customer support."
          />
        ),
      },

      {
        icon: <Why2 />,
        title: (
          <FormattedMessage id="home-why2-title" defaultMessage="Scalability" />
        ),
        text: (
          <FormattedMessage
            id="home-why2-text"
            defaultMessage="Whether you start small and need to expand, move into a new market, have a build-to-suit requirement, or need to connect to the cloud, we work hard to find solutions to support nearly any need."
          />
        ),
      },

      {
        icon: <Why3 />,
        title: (
          <FormattedMessage
            id="home-why3-title"
            defaultMessage="Power capacity"
          />
        ),
        text: (
          <FormattedMessage
            id="home-why3-text"
            defaultMessage="Optimal stability and value per square foot with the ability to lease the servers you need."
          />
        ),
      },
    ],

    side2: [
      {
        icon: <Why4 />,
        title: (
          <FormattedMessage
            id="home-why4-title"
            defaultMessage="Full-Time Expert Support"
          />
        ),
        text: (
          <FormattedMessage
            id="home-why4-text"
            defaultMessage="Get access to a variety of managed security and support solutions tailored to your infrastructure and staffing needs. "
          />
        ),
      },

      {
        icon: <Why5 />,
        title: (
          <FormattedMessage
            id="home-why5-title"
            defaultMessage="Disaster Recovery Plan"
          />
        ),
        text: (
          <FormattedMessage
            id="home-why5-text"
            defaultMessage="Setting up colocation for your disaster recovery solution keeps you online and in business 24/7/365."
          />
        ),
      },

      {
        icon: <Why6 />,
        title: (
          <FormattedMessage
            id="home-why6-title"
            defaultMessage="Additional Services"
          />
        ),
        text: (
          <FormattedMessage
            id="home-why6-text"
            defaultMessage="We provide a variety of services to set up your deployment and assist your IT department in general."
          />
        ),
      },
    ],
  },
];

export const wwdData = [
  {
    title: (
      <FormattedMessage id="Website" defaultMessage="Website Design" />
    ),
    text: (
      <FormattedMessage
        id="Creating"
        defaultMessage="Creating and launching a website from scratch or redesigning an existing one according to modern trends."
      />
    ),
  },

  {
    title: (
      <FormattedMessage id="Game" defaultMessage="Game Design" />
    ),
    text: (
      <FormattedMessage
        id="Making"
        defaultMessage="Making remarkable games on a wide variety of platforms, our team can bring the most challenging and creative ideas to life."
      />
    ),
  },

  {
    title: (
      <FormattedMessage id="Brand" defaultMessage="Brand Identity" />
    ),
    text: (
      <FormattedMessage
        id="Connected"
        defaultMessage="Creating connected brand experience and identity through digital, physical and human design."
      />
    ),
  },
];

export const portfolioData = [
  {
    img: portfolio1,
    text: (
      <FormattedMessage
        id="New"
        defaultMessage="New identity for the biggest specialist label printer. "
      />
    ),
    to: "/",
    className: "portfolioCard1",
    types: [
      {
        type: (
          <FormattedMessage
            id="Brand"
            defaultMessage="brand identity"
          />
        ),
      },
      {
        type: (
          <FormattedMessage
            id="home-portfolio1-type2"
            defaultMessage="digital design"
          />
        ),
      },
      {
        type: (
          <FormattedMessage
            id="home-portfolio1-type3"
            defaultMessage="strategy"
          />
        ),
      },
    ],
  },

  {
    img: portfolio2,
    text: (
      <FormattedMessage
        id="Transforming"
        defaultMessage="Transforming complex website into meaningful design."
      />
    ),
    to: "/",
    className: "portfolioCard2",
    types: [
      {
        type: (
          <FormattedMessage
            id="Brand"
            defaultMessage="brand identity"
          />
        ),
      },
      {
        type: (
          <FormattedMessage
            id="home-portfolio2-type2"
            defaultMessage="digital design"
          />
        ),
      },
      {
        type: (
          <FormattedMessage
            id="home-portfolio2-type3"
            defaultMessage="strategy"
          />
        ),
      },
    ],
  },

  {
    img: portfolio3,
    text: (
      <FormattedMessage
        id="High"
        defaultMessage="High-performance robots and storage systems."
      />
    ),
    to: "/",
    className: "portfolioCard3",
    types: [
      {
        type: (
          <FormattedMessage
            id="Brand"
            defaultMessage="brand identity"
          />
        ),
      },
      {
        type: (
          <FormattedMessage
            id="home-portfolio3-type2"
            defaultMessage="digital design"
          />
        ),
      },
      {
        type: (
          <FormattedMessage
            id="home-portfolio3-type3"
            defaultMessage="strategy"
          />
        ),
      },
    ],
  },

  {
    img: portfolio4,
    text: (
      <FormattedMessage
        id="Motion"
        defaultMessage="Digital design, Motion design, UX/UI design, Visual identity."
      />
    ),
    to: "/",
    className: "portfolioCard4",
    types: [
      {
        type: (
          <FormattedMessage
            id="Brand"
            defaultMessage="brand identity"
          />
        ),
      },
      {
        type: (
          <FormattedMessage
            id="home-portfolio4-type2"
            defaultMessage="digital design"
          />
        ),
      },
      {
        type: (
          <FormattedMessage
            id="home-portfolio4-type3"
            defaultMessage="strategy"
          />
        ),
      },
    ],
  },

  {
    img: portfolio5,
    text: (
      <FormattedMessage
        id="Package"
        defaultMessage="Package design, Logo design, Brand identity, Web design."
      />
    ),
    to: "/",
    className: "portfolioCard5",
    types: [
      {
        type: (
          <FormattedMessage
            id="Brand"
            defaultMessage="brand identity"
          />
        ),
      },
      {
        type: (
          <FormattedMessage
            id="home-portfolio5-type2"
            defaultMessage="digital design"
          />
        ),
      },
      {
        type: (
          <FormattedMessage
            id="home-portfolio5-type3"
            defaultMessage="strategy"
          />
        ),
      },
    ],
  },
];

export const clientsData = [
  {
    icon: <Clients1 />,
    text: (
      <FormattedMessage
        id="Nytural"
        defaultMessage="We’ve helped Nytural, multinational consumer goods company, with a refreshed branding, website design and development, and CMS development."
      />
    ),
  },

  {
    icon: <Clients2 />,
    text: (
      <FormattedMessage
        id="LearnSeek"
        defaultMessage="We've help LearnSeek understand what learners want. Using insights from interviews, we were able to evolve the UX of their platform to drive enrollment."
      />
    ),
  },

  {
    icon: <Clients3 />,
    text: (
      <FormattedMessage
        id="Helping"
        defaultMessage="Helping a fintech leader redesign web and mobile app. We have designed a modern crypto wallet to trade, buy and manage crypto hassle-free."
      />
    ),
  },
];

export const blogData = [
  {
    position: (
      <FormattedMessage
        id="UI/UX"
        defaultMessage="UI/UX Design"
      />
    ),
    date: (
      <FormattedMessage id="Jun" defaultMessage="Jun 20, 2022" />
    ),
    title: (
      <FormattedMessage
        id="14"
        defaultMessage="14 practical examples of good UX writing"
      />
    ),
    text: (
      <FormattedMessage
        id="Improve"
        defaultMessage="To help improve both your writing and your reader’s experience, we have prepared these 14 helpful UX writing examples. Whether you’re a beginner or an experienced author, it always..."
      />
    ),
    to: "/",
  },

  {
    position: (
      <FormattedMessage
        id="UI/UX"
        defaultMessage="UI/UX Design"
      />
    ),
    date: (
      <FormattedMessage id="July" defaultMessage="July 12, 2022" />
    ),
    title: (
      <FormattedMessage
        id="How"
        defaultMessage="How to build an effective product 
    development team"
      />
    ),
    text: (
      <FormattedMessage
        id="Improve"
        defaultMessage="To help improve both your writing and your reader’s experience, we have prepared these 14 helpful UX writing examples. Whether you’re a beginner or an experienced author, it always..."
      />
    ),
    to: "/",
  },

  {
    position: (
      <FormattedMessage
        id="UI/UX"
        defaultMessage="UI/UX Design"
      />
    ),
    date: (
      <FormattedMessage id="Aug" defaultMessage="Aug 22, 2022" />
    ),
    title: (
      <FormattedMessage
        id="Models"
        defaultMessage="Engagement models in IT industry"
      />
    ),
    text: (
      <FormattedMessage
        id="Improve"
        defaultMessage="To help improve both your writing and your reader’s experience, we have prepared these 14 helpful UX writing examples. Whether you’re a beginner or an experienced author, it always..."
      />
    ),
    to: "/",
  },

  {
    position: (
      <FormattedMessage
        id="UI/UX"
        defaultMessage="UI/UX Design"
      />
    ),
    date: (
      <FormattedMessage id="Jan" defaultMessage="Jan 25, 2022" />
    ),
    title: (
      <FormattedMessage
        id="Tech"
        defaultMessage="Ylliri is designing tech solutions for the 
    post-pandemic world"
      />
    ),
    text: (
      <FormattedMessage
        id="Improve"
        defaultMessage="To help improve both your writing and your reader’s experience, we have prepared these 14 helpful UX writing examples. Whether you’re a beginner or an experienced author, it always..."
      />
    ),
    to: "/",
  },
];
